import { render } from "./ParamsP2PSwap.vue?vue&type=template&id=de9064ae"
import script from "./ParamsP2PSwap.vue?vue&type=script&lang=js"
export * from "./ParamsP2PSwap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__